// extracted by mini-css-extract-plugin
export default {"nameFilter":"TaskList_nameFilter__Yru-o","taskList":"TaskList_taskList__hMuGp"};